export type MessageSenderType = 'MERCHANT' | 'CUSTOMER'

export class BookingCommunicationMessage {
    constructor(
        public id: string,
        public senderType: MessageSenderType,
        public subject: string | null,
        public messageBody: string,
        public dateCreated: Date,
        public readAt: Date | null,
    ) { }

    isMerchant(): boolean {
        return this.senderType === 'MERCHANT'
    }

    isCustomer(): boolean {
        return this.senderType === 'CUSTOMER'
    }
}
